export default {
    daysOfWeek: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"],
    limit: "Grense nådd ({{limit}} maks).",
    loading: "Laster...",
    minLength: "Min. lengde",
    months: [
        "Januar",
        "Februar",
        "Mars",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Desember"
    ],
    notSelected: "Ingen valgt",
    required: "Påkrevd",
    search: "Søk",
    dateFormat: 'dd.MM.yyyy'
}